import React, { ReactElement } from 'react';
import { PROMO_CODE_ROOT } from 'src/domains/casino/utils/test-variables';
import { observer } from 'src/utils/mobx-react';
import { SinglePromoCode } from 'src/domains/casino/webview/bonus-engine/campaign/promo-code/single-promo-code/SinglePromoCode';
import { Button } from 'src/domains/common/components/button/button';
import { useCommon } from 'src/AppState/Common';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { UploadCSVButton } from './upload-csv-button/UploadCSVButton';

type PromoCodesPropsType = {
    campaignId: string | undefined;
};

export const PromoCodes = observer('PromoCodes', ({ campaignId }: PromoCodesPropsType): ReactElement => {
    const common = useCommon();
    const { promoCodesState, editionDisabled } = CampaignCreatorState.get(common, campaignId);
    return (
        <div
            className='grid grid-cols-2 gap-2'
            data-test={PROMO_CODE_ROOT}
        >
            <div className='flex flex-col gap-8 max-w-screen-md'>
                <section className='flex flex-col gap-6'>
                    <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>
                        Total Created: {promoCodesState.codeList.length}
                    </h2>
                    <div className='flex flex-col gap-4'>
                        <div className='grid w-full grid-cols-[5fr_5fr_1fr] gap-2'>
                            <div className='block mb-2 text-sm'>Promo Code</div>
                            <div className='block mb-2 text-sm'>Use limit</div>
                            <div></div>
                        </div>
                        {promoCodesState.codeList.map((promoCode, index) => (
                            <SinglePromoCode
                                index={index}
                                key={promoCode.id}
                                promoCodeState={promoCode}
                                campaignId={campaignId}
                            />
                        ))}
                    </div>
                    <div className='flex gap-4 w-full'>
                        <Button
                            className='box-dashed w-1/2'
                            icon='plus'
                            onClick={promoCodesState.addPromoCode}
                            variant='outline'
                            size='default'
                            disabled={editionDisabled}
                        >
                            Add Manually
                        </Button>
                        <UploadCSVButton
                            promoCodesState={promoCodesState}
                            disabled={editionDisabled}
                        />
                    </div>
                </section>
            </div>
        </div>
    );
});
